import type {
    SnackBarInternalProps
} from "./type";
import type {
    ToastInternalProps
} from "../toast/type";
import {
    warnOnce
} from "../../utils/development";

type SnackBarOwnKeys = "isInlineSafeArea" | "isFullWidth" | "topOffset";

type SnackBarToastProps<T> = Omit<T, SnackBarOwnKeys> & Pick<ToastInternalProps, "side" | "stackMode" | "isCompact" | "isShowAction" | "isShowClose" | "spreadBehaviour" | "edgeOffset">;

export const getSnackBarToastProps = <T extends Partial<SnackBarInternalProps>>({
    isShowAction = true,
    isInlineSafeArea,
    spreadBehaviour,
    isFullWidth,
    isShowClose,
    topOffset,
    ...rest
}: T): SnackBarToastProps<T> => {
    warnSnackBarDeprecated({
        isInlineSafeArea
    });

    return {
        ...rest,
        spreadBehaviour: isFullWidth ? "stretch" : spreadBehaviour,
        isShowClose: isShowClose ?? isShowAction,
        edgeOffset: topOffset,
        stackMode: "list",
        isCompact: false,
        isShowAction,
        side: "top"
    } as unknown as SnackBarToastProps<T>;
};

export const warnSnackBarDeprecated = ({
    isInlineSafeArea
}: {
    isInlineSafeArea?: boolean;
}) => {
    warnOnce({
        message: "SnackBar is deprecated and will be removed in the next major version. Use Toast with side=\"top\" and stackMode=\"list\" instead."
    });

    if(isInlineSafeArea === undefined) {
        return;
    }

    warnOnce({
        message: "SnackBar: \"isInlineSafeArea\" is deprecated and will be removed in the next major version. The SnackBar always sits below the safe area with a spacingSm gap."
    });
};
